import type { LangNameProps } from "./language-name.type";

import { Skeleton } from "antd";

import { useReferentialLanguages } from "@/entities/referential/referential-languages";
import { Tag } from "@/ui/tag";

const LangName = ({ code }: LangNameProps) => {
  const { languages, isLoading } = useReferentialLanguages();
  const lang = languages.find((lang) => lang.code === code);

  if (isLoading) {
    return <Skeleton.Input active size="small" />;
  }
  if (!lang?.name) return null;

  return <Tag>{lang.name}</Tag>;
};

export default LangName;
